import React, { useEffect, useState } from "react";

type Particle = {
  id: number;
  x: number;
  y: number;
  tx: string;
  ty: string;
  rotate: string;
  duration: string;
  type: "spark" | "diamond";
};

let particleId = 0;

const DoorParticles: React.FC<{
  x: number;
  y: number;
  trigger: boolean;
}> = ({ x, y, trigger }) => {
  const [particles, setParticles] = useState<Particle[]>([]);

  useEffect(() => {
    if (!trigger) return;

    const newParticles: Particle[] = Array.from({ length: 25 }).map(() => {
      const angle = Math.random() * Math.PI * 2;
      const dist = 40 + Math.random() * 50;

      return {
        id: particleId++,
        x,
        y,
        tx: `${Math.cos(angle) * dist}px`,
        ty: `${Math.sin(angle) * dist}px`,
        rotate: `${Math.random() * 360}deg`,
        duration: `${0.5 + Math.random() * 0.4}s`,
        type: Math.random() > 0.5 ? "diamond" : "spark",
      };
    });

    setParticles((prev) => [...prev, ...newParticles]);

    const timer = setTimeout(() => {
      setParticles((prev) =>
        prev.filter((p) => !newParticles.includes(p))
      );
    }, 1000);

    return () => clearTimeout(timer);
  }, [trigger, x, y]);

  return (
    <div className="fx-layer">
      {particles.map((p) => (
        <div
          key={p.id}
          className={`particle particle-${p.type}`}
          style={{
            left: p.x,
            top: p.y,
            "--tx": p.tx,
            "--ty": p.ty,
            "--rot": p.rotate,
            "--duration": p.duration,
          } as React.CSSProperties}
        />
      ))}
    </div>
  );
};

export default DoorParticles;